<section
  class="dashboard-widget-card__body"
  [class.dashboard-widget-card__body--compact]="compact"
  [class.dashboard-widget-card__body--built-in]="isBuiltInBody"
  [class.dashboard-widget-card__body--default]="isDefaultBody">
  <ng-content></ng-content>
</section>
